import { render, staticRenderFns } from "./imgTem.vue?vue&type=template&id=12ee19fe&scoped=true&"
import script from "./imgTem.vue?vue&type=script&lang=js&"
export * from "./imgTem.vue?vue&type=script&lang=js&"
import style0 from "./imgTem.vue?vue&type=style&index=0&id=12ee19fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ee19fe",
  null
  
)

export default component.exports